<template>
  <component :is="tag" class="body-text">
      <slot/>
  </component>
</template>

<script>
export default {
  name: 'BodyText',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style lang="scss" scoped>
$component: '.body-text';
#{$component} {
  font-size: $font-size-xl;
  color: $color-sys-e;
  /deep/ h1,
  /deep/ h2,
  /deep/ h3,
  /deep/ h4,
  /deep/ h5,
  /deep/ h6 {
    color: $color-sys-b;
    margin: $gutter 0;
  }
  /deep/ p {
    font-size: inherit;
    margin: 0 0 $gutter-xxl;
    line-height: $line-height-xl;
  }
  /deep/ a {
    font-weight: $font-weight-bold;
    color: $color-a;
    transition: color $transition-duration $transition-timing-function;
    &:hover {
      color: $color-b;
    }
  }
  /deep/ ul {
    box-sizing: border-box;
    margin-bottom: $gutter-xxl;
    list-style: disc;
    li {
      display: grid;
      grid-template-columns: $gutter-l auto;
      grid-template-rows: auto;
      grid-gap: $gutter;
      margin-bottom: $gutter;
      &:before {
        display: flex;
        align-intems: center;
        justify-content: center;
        content: '\002022';
        color: $color-a;
      }
    }
  }
  /deep/ picture {
    display: block;
    margin-left: -$gutter-l;
    img {
      display: block;
      width: 100%;
      border-radius: $border-radius;
    }
    p {
      display: inline-block;
      margin: 0;
      padding: $gutter $gutter-l;
      font-size: $font-size-s;
      line-height: $line-height-xl;
      color: $color-sys-e;
    }
    &.right,
    &.left {
      width: 50%;
      margin-top: $gutter-l;
      p {
        padding: $gutter 0;
      }
    }
    &.right {
      float: right;
      margin-left: $gutter-l;
    }
    &.left {
      float: left;
      margin-right: $gutter-l;
    }
  }
}
@media screen and (max-width: #{$brakepoint-medium}) {
  #{$component} {
    /deep/ ul {
      display: block;
      li {
        margin-bottom: $gutter-l;
      }
    }
    /deep/ picture {
      margin-left: 0;
      p {
        padding-left: 0;
      }
      &.right,
      &.left {
        float: none;
        width: 100%;
      }
    }
  }
}
</style>
